module.exports = __webpack_public_path__ + "static/video_meeting-e7883f0b6ffd7635a9db0d7d514146f4.png";